export const metaConfig = {
  home: {
    title:
      "alist.ae - Dubai's Leading Influencer Marketing Platform for Brands & Creators",
    meta: [
      {
        name: "description",
        content:
          "Connect with top influencers in Dubai! alist.ae is the leading influencer marketing platform for brands & creators across industries. Grow your reach today!",
      },
      {
        rel: "canonical",
        href: "https://www.alist.ae/",
      },
      {
        property: "og:title",
        content:
          "alist.ae - Dubai's #1 Platform for Influencers to Monetize Their Brand Deals",
      },
      {
        property: "og:description",
        content:
          "The ultimate influencer marketing platform in Dubai. Brands find perfect creators, influencers get paid campaigns. Join alist.ae!",
      },
      {
        property: "og:url",
        content: "https://www.alist.ae/",
      },
      {
        name: "twitter:title",
        content:
          "alist.ae - Dubai's Go-To Influencer Platform for Brands & Creators",
      },
      {
        name: "twitter:description",
        content:
          "The ultimate influencer marketing platform in Dubai. Brands find perfect creators, influencers get paid campaigns. Join alist.ae!",
      },
    ],
  },
  brands: {
    title: "Influencer Marketing Platform for Brands in Dubai | alist.ae",
    meta: [
      {
        name: "description",
        content:
          "Partner with top creators in Dubai to promote your brand. alist.ae helps you connect with influencers and drive real exposure through authentic content.",
      },
      {
        rel: "canonical",
        href: "https://www.alist.ae/brands/",
      },
      {
        property: "og:title",
        content:
          "Dubai's Top Influencer Marketplace – Hire Creators on alist.ae",
      },
      {
        property: "og:description",
        content:
          "Join alist.ae, the go-to platform in Dubai for brands to discover, hire, and collaborate with top influencers. Scale your brand with authentic creator partnerships.",
      },
      {
        property: "og:url",
        content: "https://www.alist.ae/brands/",
      },
      {
        name: "twitter:title",
        content:
          "Hire Influencers in Dubai | Creator Marketplace for Brands | alist.ae",
      },
      {
        name: "twitter:description",
        content:
          "Find and hire top content creators in Dubai with alist.ae. The influencer marketplace trusted by brands to drive real results.",
      },
    ],
  },
  creators: {
    title:
      "Become a Paid Content Creator for Brands | Join Dubai's Creator Network",
    meta: [
      {
        name: "description",
        content:
          "Join alist.ae to get paid for creating content for top brands in Dubai. Become a content creator, collaborate with leading brands, and grow your influencer career.",
      },
      {
        rel: "canonical",
        href: "https://www.alist.ae/creators",
      },
      {
        property: "og:title",
        content:
          "Become a Brand Creator and Earn from Your Content | alist.ae Dubai",
      },
      {
        property: "og:description",
        content:
          "alist.ae helps you connect with brands seeking authentic content creators. Apply now to get paid for creating branded content and boost your creator profile.",
      },
      {
        property: "og:url",
        content: "https://www.alist.ae/creators",
      },
      {
        name: "twitter:title",
        content:
          "Create for Brands & Get Paid | Join Dubai's Creator Network | alist.ae",
      },
      {
        name: "twitter:description",
        content:
          "Start your journey as a paid influencer. alist.ae connects creators with brands in Dubai. Share your content, grow your audience, and earn every step of the way.",
      },
    ],
  },
  overview: {
    title:
      "The alist.ae Advantage | First End-to-End Influencer Marketing Platform",
    meta: [
      {
        name: "description",
        content:
          "Discover the alist.ae advantage - the first and only end-to-end influencer marketing platform connecting brands with creators for powerful, data-driven collaborations.",
      },
      {
        rel: "canonical",
        href: "https://www.alist.ae/overview",
      },
      {
        property: "og:title",
        content:
          "Experience the alist.ae Advantage - Complete Influencer Marketing Solution",
      },
      {
        property: "og:description",
        content:
          "alist.ae is the only all-in-one influencer platform built for brands and creators. From discovery to campaign performance, manage everything in one place.",
      },
      {
        property: "og:url",
        content: "https://www.alist.ae/overview",
      },
      {
        name: "twitter:title",
        content:
          "The alist.ae Advantage | One Platform, Endless Influencer Possibilities",
      },
      {
        name: "twitter:description",
        content:
          "alist.ae offers the only complete influencer solution in the region. Discover, connect, and grow — all in one end-to-end platform for creators and brands.",
      },
    ],
  },
};
